import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article", "vehicleField", "direction"]
  static values = { articleDirections: Object }

  connect() {
    // Wait for TomSelect to initialize
    requestAnimationFrame(() => {
      this.saveAllOptions()
      this.filterArticles()
      this.toggleVehicle()
    })
  }

  saveAllOptions() {
    const ts = this.articleTarget.tomselect
    if (!ts) return
    this.allOptions = { ...ts.options }
    this.allOptgroups = { ...ts.optgroups }
  }

  filterArticles() {
    const ts = this.articleTarget.tomselect
    if (!ts || !this.allOptions) return

    const direction = this.directionTarget.value
    const directions = this.articleDirectionsValue
    const currentValue = ts.getValue()

    ts.clearOptions()

    // Re-add optgroups
    Object.values(this.allOptgroups).forEach(og => {
      ts.addOptionGroup(og.value || og.$order, og)
    })

    // Re-add matching options
    Object.values(this.allOptions).forEach(opt => {
      const articleId = parseInt(opt.value)
      if (!direction || directions[articleId] === direction) {
        ts.addOption(opt)
      }
    })

    // Restore selection if it still matches, otherwise clear
    if (currentValue && directions[parseInt(currentValue)] === direction) {
      ts.setValue(currentValue, true)
    } else if (direction && currentValue) {
      ts.clear(true)
    }

    ts.refreshOptions(false)
    this.toggleVehicle()
  }

  toggleVehicle() {
    const select = this.articleTarget
    const selectedOption = select.selectedOptions?.[0]
    const articleName = selectedOption?.text || ""
    const isTransport = /транспорт/i.test(articleName)

    if (this.hasVehicleFieldTarget) {
      this.vehicleFieldTarget.style.display = isTransport ? "" : "none"
    }
  }
}
